<div class="tab" v-show="isActive" v-bind="$attrs"><slot></slot></div>